























































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {DialogRemove} from '@/helpers/dialog/DialogRemove'
import {Carga} from '@/model/resource/Carga'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {ListCargaSchema} from '@/schema/resource/Carga/ListCargaSchema'
import {CsvCargaSchema} from '@/schema/resource/Carga/CsvCargaSchema'
import {Env} from '@/helpers/Env'

@Component
export default class ListCargaView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaSchema()
  collection = new CargaCollection()

  async created() {
    await this.query()
  }

  async removeItem(item: Carga) {
    await new DialogRemove(item).confirm(() => item.removeCarga())
    await this.collection.listCarga()
  }

  async removeByCsv() {
    const file = await Helper.promptForSingleFile('.csv')

    if (file) {
      const data = await Helper.csvToNormalizedData(
        file,
        Env.CSV_BLUEPRINT.removeCarga
      )

      const ids = data.map(item => Number(item.id))

      if (ids.some(id => isNaN(id))) {
        Helper.abort('system.error.wrongFormat')
      }

      const response = await Carga.batchRemoveCarga(ids)
      const {successQty, ignoredQty} = response

      if (ignoredQty) {
        this.$snotify.warning(
          this.$t('system.info.cargaIgnored', {ignoredQty}) as string
        )
      }

      await Helper.sleep(500)

      this.$snotify.success(
        this.$t('system.info.cargaRemoved', {successQty}) as string
      )

      await this.collection.listCarga()
    }
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaCollection().clearFilters().addFilter(params)

    await csv.listCsvCarga()
    new CsvCargaSchema().downloadCsv(csv.all())
  }
}
